import React, { useState, useEffect, useCallback, useRef } from "react";
import { Layout, Button } from "antd";
import {
    Row,
    Form,
    Input,
    Col,
    Select,
    Collapse,
    notification,
    Popconfirm,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";

import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import Pagination from "../../common/Pagination/Pagination"; 
import "../../common/Pagination/Pagination.css"; 

import {
    MinusCircleTwoTone,
    PlusCircleTwoTone,
    DeleteOutlined,
} from "@ant-design/icons";
import QuestionnairesApi from "../../common/Apis/QuestionnairesApi";
import CleaningTraceabilityItemApi from "../../common/Apis/CleaningTraceabilityItemApi";
const CleaningTraceabilityItem = () => {
    let navigate = useNavigate();
    const { Content } = Layout;
    const { Panel } = Collapse;
    const [TraceabilityItems, setTraceabilityItem] = React.useState([]);
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));

    const [PaginatePage, setPaginatePage] = useState(0);
    const [PaginatetotalPages, settotalPages] = useState(null);
    const [PaginateLimit, setPaginateLimit] = useState(10);
    const [formPaginate] = Form.useForm();
    const [totalElements, setTotalElements] = useState(0);

    formPaginate.setFieldsValue({
        paginate: PaginateLimit,
    });
    const handlesetPaginateLimit = (value) => {
        setPaginateLimit(value);
        setCurrentPage(1);
        formPaginate.setFieldsValue({
            paginate: value,
        });
        CleaningTraceabilityItemApi.ListTraceabilityItemApi(0, value)
            .then((response) => {
                settotalPages(response.totalPages);
                setTraceabilityItem(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    };
    const [currentPage, setCurrentPage] = useState(1);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        let pageNew = page - 1
        CleaningTraceabilityItemApi.ListTraceabilityItemApi(pageNew, PaginateLimit)
            .then((response) => {
                setPaginatePage(pageNew)
                settotalPages(response.totalPages);
                setTraceabilityItem(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    };


    const getTraceabilityItem = useCallback(() => {
        CleaningTraceabilityItemApi.ListTraceabilityItemApi(PaginatePage, PaginateLimit)
            .then((response) => {
                settotalPages(response.totalPages);
                setTraceabilityItem(response.payloadDto?.sort((a, b) => b.id - a.id));
                setTotalElements(response.totalElements);

            })
            .catch((err) => {
                console.log(err);
            });
    }, []);
    const [isLoading, setIsLoading] = useState(false);
    const PageLoading = useCallback(() => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
    }, []);

    useEffect(() => {
        getTraceabilityItem();
        PageLoading();
    }, [getTraceabilityItem, PageLoading]);


    const handleDeleteTraceability = (Traceability) => {
        CleaningTraceabilityItemApi.DeleteTraceabilityItemApi(Traceability)
            .then((response) => {
                notification.open({
                    message: <span style={{ fontWeight: "bold" }}>Deleted</span>,
                    description: "Delete Successfully",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#b3ffb3",
                        color: "green",
                    },
                });
                PageLoading();
                getTraceabilityItem();
            })
            .catch((err) => {
                if (err.apiError.status) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>Error</span>,
                        description: err.apiError.message,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff2f0",
                            color: "red",
                        },
                    });
                }
            });
    };
    const handleRemovefilterTraceability = (FiltergetTraceabilityIndex) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability.splice(FiltergetTraceabilityIndex, 1);
        setFilterTraceability(newfilterTraceability);
        if (FiltergetTraceabilityIndex == 0) {
            getTraceabilityItem();
        }
    };
    const handleClear = () => {
        getTraceabilityItem();
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        setFilterTraceability([
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };
    const formRef = useRef(null);

    const [filterTraceabilityItem, setFilterTraceability] = useState([
        {
            title: "",
            answerType: "",
            name: "",
        },
    ]);

    const handleAddfilterTraceability = () => {
        setFilterTraceability([
            ...filterTraceabilityItem,
            {
                title: "",
                answerType: "",
                name: "",
            },
        ]);
    };

    const handleSubmit = (data) => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
        }, 800);
        let singleLineString = filterTraceabilityItem
            .map((obj) => {
                if (obj.answerType === "%") {
                    return `${obj.title}=${obj.answerType}${obj.name}${obj.answerType}`;
                } else if (obj.answerType === "=") {
                    return `${obj.title}${obj.answerType}${obj.name}`;
                } else {
                    return `${obj.title}=${obj.name}`;
                }
            })
            .join("&");

        let filderData = window.btoa("componentCode=CLEANING_TRACEABILITY_ITEM&subTenant.id=" + decodedToken?.subTenantId + "&" + singleLineString
);
        QuestionnairesApi.FilterQuestionsetNext(filderData, 0, PaginateLimit)
            .then((response) => {
                setCurrentPage(1);
                settotalPages(response.totalPages);
                setTraceabilityItem(response.payloadDto);
                setTotalElements(response.totalElements);

            })
            .catch((err) => { });
    };
    const handleChangeTitle = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].title = value;
        setFilterTraceability(newfilterTraceability);
    };
    const handleChangeAnswertype = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].answerType = value;
        setFilterTraceability(newfilterTraceability);
    };

    const handleChangename = (FiltergetTraceabilityItemIndex, value) => {
        const newfilterTraceability = [...filterTraceabilityItem];
        newfilterTraceability[FiltergetTraceabilityItemIndex].name = value;
        setFilterTraceability(newfilterTraceability);
    };

    const paginatedData = TraceabilityItems;

    const renderTableRows = () => {
        if (paginatedData.length > 0) {
            return paginatedData.map((item) => (
                <tr key={item?.id} className="text-center">

                    <td style={{ width: "30%" }} className="pt-3">
                        {item?.traceabilityName}
                    </td> <td style={{ width: "30%" }} className="pt-3">
                        {item?.institutionDTO?.institutionName}
                    </td>

                    <td style={{ width: "10%" }}>
                        <div className="d-flex ">
                            {/* <Link
                                to={`/cleaning-traceability/cleaning-list/edit-cleaning-traceability-item?id=${item?.id}`}
                                className={decodedToken?.permissions?.some(
                                    (permission) => permission?.authority === 'EDIT_CLEANING_TRACEABILITY_ITEM'
                                ) ? 'btn btn-primary btn-save table-action icon-center w-100' : 'd-none'}
                            >
                                <EditOutlined />
                                Edit
                            </Link> */}
                            <Popconfirm
                                title="Are you sure ?"
                                description="Do you really want to delete this Traceability Item ?"
                                okText="Yes"
                                onConfirm={() => handleDeleteTraceability(item.id)}
                                placement="topRight"
                                className="w-100"
                                cancelText="No"
                            >
                                <Link
                                    to={``}
                                    className={decodedToken?.permissions?.some(
                                        (permission) => permission?.authority === 'DELETE_CLEANING_TRACEABILITY_ITEM'
                                    ) ? 'btn btn-primary btn-back table-action icon-center mx-1' : 'd-none'}
                                >
                                    <DeleteOutlined />
                                    Delete
                                </Link>
                            </Popconfirm>
                        </div>
                    </td>
                </tr>
            ));
        } else {
            return (
                <tr className="text-center EmptyTable">
                    <td colSpan={3} className="text-center ">
                        <img
                            src="/assest/Images/emptyIcon.svg"
                            className="logo-png mt-3"
                            style={{ width: "10%" }}
                        />
                        <br />
                        <Button
                            className={decodedToken?.permissions?.some(
                                (permission) => permission?.authority === 'ADD_CLEANING_TRACEABILITY_ITEM'
                            ) ? 'btn btn-primary btn-save m-0 my-4' : 'd-none'}
                            href={"/cleaning-traceability/cleaning-list/add-cleaning-traceability-item"}
                        >
                            Add Traceability Item
                        </Button>
                    </td>
                </tr>
            );
        }
    };


    return (
        <Layout style={{ minHeight: "100vh" }}>
            <Sidebar />
            <Layout>
                <TopHeader />
                {isLoading && (
                    <div className="spinner-overlay" id="spinnerOverlay">
                        <div className="spinner"></div>
                    </div>
                )}
                <div
                    style={{
                        padding: "20px",
                        paddingBottom: "5px",
                    }}
                >
                    <Form
                        ref={formRef}
                        name="nest-messages"
                        layout="vertical"
                        className="FormClass FilterForm"
                        onFinish={handleSubmit}
                    >
                        <>
                            <Collapse>
                                <Panel
                                    header={
                                        <h5 className="mb-0">
                                            <b>Filter</b>
                                        </h5>
                                    }
                                    key="1"
                                >
                                    {filterTraceabilityItem.map((input, filterTraceabilityItemIndex) => (
                                        <div key={filterTraceabilityItemIndex}>
                                            <Row gutter={12} className="pt-2">
                                                <Col span={5}>
                                                    <Form.Item
                                                        name={`title${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select"
                                                            placeholder="Filter By"
                                                            value={input.title}
                                                            onChange={(value) =>
                                                                handleChangeTitle(filterTraceabilityItemIndex, value)
                                                            }
                                                            options={[
                                                                {
                                                                    value: "traceabilityName",
                                                                    label: "Traceability Item",
                                                                },
                                                                {
                                                                    value: "department",
                                                                    label: "Department",
                                                                },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={4}>
                                                    <Form.Item
                                                        name={`type${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please Select type.",
                                                            },
                                                        ]}
                                                    >
                                                        <Select
                                                            className="control-Select mb-1"
                                                            placeholder="Condition"
                                                            onChange={(value) =>
                                                                handleChangeAnswertype(
                                                                    filterTraceabilityItemIndex,
                                                                    value
                                                                )
                                                            }
                                                            options={[
                                                              { value: "%", label: "Matches with" },
                                                              {
                                                                value: "=",
                                                                label: "Equals to",
                                                              },
                                                            ]}
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={5}>
                                                    <Form.Item
                                                        name={`name${filterTraceabilityItemIndex}`}
                                                        className="text-lable"
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "Please enter Text.",
                                                            },
                                                        ]}
                                                    >
                                                        <Input
                                                            type="text"
                                                            onChange={(e) =>
                                                                handleChangename(
                                                                    filterTraceabilityItemIndex,
                                                                    e.target.value
                                                                )
                                                            }
                                                            placeholder="Text"
                                                            className="control-input"
                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col span={8}>
                                                    <Form.Item className="text-lable">
                                                        {filterTraceabilityItemIndex == 0 ? (
                                                            <>
                                                                <Row gutter={23} className="mb-3">
                                                                    <Col span={2} className="mx-0">
                                                                        <Form.Item className="text-lable">
                                                                            <PlusCircleTwoTone
                                                                                onClick={handleAddfilterTraceability}
                                                                            />
                                                                        </Form.Item>
                                                                    </Col>

                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="primary"
                                                                            htmlType="submit"
                                                                            className="btn btn-primary btn-save table-action icon-center "
                                                                        >
                                                                            Filter
                                                                        </Button>
                                                                    </Col>
                                                                    <Col span={10}>
                                                                        <Button
                                                                            type="reset"
                                                                            htmlType="reset"
                                                                            onClick={() => handleClear()}
                                                                            style={{ color: "#0b5ed7" }}
                                                                            className="btn btn-primary btn-back table-action icon-center"
                                                                        >
                                                                            Clear
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            </>
                                                        ) : (
                                                            <>
                                                                {" "}
                                                                <MinusCircleTwoTone
                                                                    onClick={() =>
                                                                        handleRemovefilterTraceability(
                                                                            filterTraceabilityItemIndex
                                                                        )
                                                                    }
                                                                />
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </div>
                                    ))}
                                </Panel>
                            </Collapse>
                        </>
                    </Form>
                </div>
                <Content
                    className="form-content nav-content"
                    style={{
                        margin: "14px 16px 0",
                        padding: "30px",
                        background: "white",
                    }}
                >
                    <div>

                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                {paginatedData.length > 0 && (
                                    <Button
                                        className={decodedToken?.permissions?.some(
                                            (permission) => permission?.authority === 'ADD_CLEANING_TRACEABILITY_ITEM'
                                        ) ? 'btn btn-primary btn-save m-0 my-2' : 'd-none'}
                                        href={"/cleaning-traceability/cleaning-list/add-cleaning-traceability-item"}
                                    >
                                        Add Traceability Item
                                    </Button>
                                )}
                            </div>
                            <div>

                                <Form
                                    form={formPaginate}
                                >
                                    <Form.Item
                                        name="paginate"
                                        className="text-lable"
                                        style={{ width: '100px' }}
                                    >
                                        <Select
                                            className="control-Select"
                                            onChange={(value) => {
                                                handlesetPaginateLimit(value)
                                            }}
                                            options={[
                                                { value: 10, label: "10" },
                                                { value: 20, label: "20" },
                                                { value: 30, label: "30" },
                                                { value: 40, label: "40" },
                                                { value: 50, label: "50" },
                                            ]}
                                        />
                                    </Form.Item>
                                </Form>

                            </div>
                        </div>
                        <table className="table users-table">
                            <thead>
                                <tr>
                                    <th>Cleaning Traceability Item</th>
                                    <th>Department</th>
                                    <th className="text-center">Action</th>
                                </tr>
                            </thead>
                            <tbody>{renderTableRows()}</tbody>
                        </table>
                       {paginatedData.length > 0 && (
                        <Pagination
                            currentPage={currentPage}
                            totalPages={PaginatetotalPages}
                            onPageChange={handlePageChange}
                            maxVisiblePages={5}
                            showPageInfo={true}
                            totalItems={totalElements}
                            pageSize={PaginateLimit}
                        />
                        )}
                    </div>
                </Content>

                {/* <FooterDashboard /> */}
            </Layout>
        </Layout>
    );
};

export default CleaningTraceabilityItem;
